import { observable, action, computed } from 'mobx';
import { localStorage } from 'common/storage';
import { authService } from 'common/security';

const TOKEN_STORAGE_KEY = 'paperwork_token_storage_key';
//const USER_STORAGE_KEY = 'paperwork_user_storage_key';

class AuthStore {
    @observable token = null;
    @observable user = null;
    @observable error = null;
    @observable loadingUser = false;

    @computed get isAuthenticated() {
        return isSome(this.token)
            && isSome(this.token.access_token)
            && isSome(this.token.expires_in)
            && (this.token.expiryDate - new Date().getTime()) > 0;
    }

    @action
    setSession(token) {
        if (isSome(token)) {
            if (!isSome(token.expiryDate)) {
                var t = new Date(new Date().getTime() + token.expires_in * 1000);
                token.expiryDate = t;
            }

            this.token = token;
            this.storeToken(token);
        } else {
            this.removeSession();
        }
    }

    @action
    removeSession() {
        this.token = null;
        this.user = null;
        localStorage.removeItem(TOKEN_STORAGE_KEY);
    }

    @action
    setUser(user) {
        this.user = user;
    }

    @action
    setLoadingUser(loading) {
        this.loadingUser = loading;
    }

    @action
    async loadUser() {
        this.setLoadingUser(true);
        try {
            var user = await authService.getUser();
            this.setUser(user);
        } catch(error) {
            this.setUser(null);            
        }                

        this.setLoadingUser(false);
    }

    async initialize() {
        const token = this.getToken();
        if (token) {
            this.setSession(token);
            try {
                await this.loadUser();
            } catch (ex) {

            }
        }
        localStorage.addEventListener(this.onStorageChanged);
    }

    storeToken(token) {
        localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(token));
    }

    getToken() {
        return this.parseToken(localStorage.getItem(TOKEN_STORAGE_KEY));
    }

    parseToken(tokenString) {
        if (tokenString === null || tokenString === undefined) {
            return null;
        }

        const token = JSON.parse(tokenString);
        if (isSome(token.expiryDate)) {
            token.expiryDate = new Date(token.expiryDate);
        }
        return token;
    }

    onStorageChanged = (event) => {
        if (event.key === TOKEN_STORAGE_KEY) {
            const token = this.parseToken(event.newValue);
            this.setSession(token);
        }
    }

    getAccessToken = () => {
        return this.isAuthenticated ? this.token.access_token : null;
    }

    getRefreshToken = () => {
        return this.isAuthenticated ? this.token.refresh_token : null;
    }

    userIsInRole = (roleName) => {
        return this.user.roles.includes(roleName);
    }
}

function isSome(value) {
    return value !== null && value !== undefined;
}

const authStore = new AuthStore();
export { authStore }


// WEBPACK FOOTER //
// ./src/stores/authStore.js